import { Pipe, PipeTransform } from "@angular/core";
import { STRING } from "../constants/string";

@Pipe({
  name: "initials",
})
export class InitialsPipe implements PipeTransform {
  transform(value?: string): string {
    if (!value) {
      return STRING.EMPTY;
    }

    return value.split(STRING.SPACE)
      .map(el => el.charAt(0))
      .filter(Boolean)
      .join(STRING.EMPTY)
      .toUpperCase();
  }
}
